module.exports = __webpack_public_path__ + "media/images/emblems/Genthod-coat_of_arms-64359946ed56e16ff567b403d53a3ee8.svg";